import React from 'react';
import { ExternalLink } from 'lucide-react';

// "Open full page" inside a quick-look modal.
const OpenFullPageLink = ({ onClick, label = 'Open full page' }) => (
  <button
    type="button"
    onClick={onClick}
    className="flex-shrink-0 inline-flex items-center gap-1 px-2.5 py-1.5 rounded-md text-xs font-semibold text-blue-600 dark:text-blue-400 hover:underline hover:bg-blue-50 dark:hover:bg-slate-800 cursor-pointer"
  >
    <ExternalLink size={14} /> {label}
  </button>
);

export default OpenFullPageLink;
